module.exports = __webpack_public_path__ + "static/media/node.8c02c34f.png";